/**
 * DashboardTopBar
 * canonical: lines 599–605
 *
 * .topbar row: crumb "Dashboard" on the left,
 * ↗ Export (ghost) + + New Project (dark) on the right.
 *
 * Export: downloads a CSV of the ARIA follow-up queue.
 */

import { useState }      from 'react'
import { useNavigate }   from 'react-router-dom'
import { fetchFollowUpQueue } from '../../api/dashboard'
import type { FollowUpItem }  from '../../api/types'

/* canonical: lines 599–605 */
export function DashboardTopBar() {
  const navigate            = useNavigate()
  const [exporting, setExporting] = useState(false)

  async function handleExport() {
    if (exporting) return
    setExporting(true)
    try {
      const result = await fetchFollowUpQueue()
      const queue: FollowUpItem[] = result?.queue ?? []

      const headers = ['Project', 'App #', 'Amount Due', 'Days Overdue', 'Tone']
      const rows = queue.map((item) => [
        `"${(item.project_name ?? '').replace(/"/g, '""')}"`,
        item.app_number ?? '',
        item.amount_due ?? 0,
        item.days_overdue ?? 0,
        item.tone ?? '',
      ])
      const csv  = [headers.join(','), ...rows.map((r) => r.join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url  = URL.createObjectURL(blob)
      const a    = document.createElement('a')
      a.href     = url
      a.download = `aria-actions-${new Date().toISOString().slice(0, 10)}.csv`
      a.click()
      URL.revokeObjectURL(url)
    } catch {
      // silent fail — user sees no change
    } finally {
      setExporting(false)
    }
  }

  return (
    <div className="topbar">
      {/* canonical: line 600 — .crumb */}
      <div className="crumb"><b>Dashboard</b></div>

      {/* canonical: lines 601–604 — .topbar-r */}
      <div className="topbar-r">
        <button
          className="btn b-gh btn-sm"
          onClick={() => navigate('/reports/operations')}
          data-testid="dashboard-view-ops-report"
        >
          Operations report →
        </button>
        <button
          className="btn b-gh btn-sm"
          onClick={handleExport}
          disabled={exporting}
          data-testid="dashboard-export-btn"
        >
          {exporting ? 'Exporting…' : '↗ Export'}
        </button>
        <button
          className="btn b-dk btn-sm"
          onClick={() => navigate('/projects/new')}
          data-testid="dashboard-new-project-btn"
        >
          + New Project
        </button>
      </div>
    </div>
  )
}
